export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const createSettersObjectFromFilters = (
  filters,
  setQsFilters,
  updateQueryParam
) => {
  return Object.keys(filters).reduce((acc, filter) => {
    return {
      ...acc,
      [`set${capitalizeFirstLetter(filter)}`]: newValue => {
        setQsFilters(prev => ({ ...prev, [filter]: newValue }));
        updateQueryParam(filter, filters[filter]?.toQs(newValue));
      }
    };
  }, {});
};

export const getInitFiltersValues = filters => {
  return Object.keys(filters)
    .filter(filter => filters[filter].defaultValue)
    .reduce((acc, filter) => {
      return { ...acc, [filter]: filters[filter]?.defaultValue };
    }, {});
};

export const convertFilterFromQSToLocalFilter = (filter, value) => {
  let fromQSFilterValue;
  try {
    fromQSFilterValue = filter.fromQs(value);
  } catch (e) {
    fromQSFilterValue = value;
  }
  return fromQSFilterValue;
};
